import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { useLoadAds } from '@/contexts/ads'

// Note: (un)comment CSS if separate mobile ad (not) provided
import styles from './MidBanner.module.scss'

const MidBanner = () => {
  const loadAds = useLoadAds()

  // https://www.epochconverter.com
  const enabled = Date.now() >= 1732888800000 && Date.now() < 1733187600000

  if (!enabled || loadAds !== true) return null

  return (
    <div className={styles.container}>
      <OutboundLink className={styles.link} url='MY_URL'>
        {/* <img className='d-none d-sm-block' src={MY_IMAGE.src} alt='MY ALT' />
        <img className='d-sm-none' src={MY_IMAGE.src} alt='MY ALT' /> */}
        {/* <img src={MY_IMAGE.src} alt='MY ALT' /> */}
      </OutboundLink>
    </div>
  )
}

export default MidBanner
